import { SubscriptionConnectableData } from '../../subscription-connectable-data';
import { VersionedUserData } from '../../versioned-user-data';

export interface BillingAddress extends SubscriptionConnectableData, VersionedUserData {
  id: number;
  firstName: string | null;
  lastName: string | null;
  organizationName: string | null;
  address: string | null;
  address2: string | null;
  postalCode: string | null;
  city: string | null;
  province: string | null;
  country: string;
  email: string | null;
  vatId: string | null;
  vatVerified: boolean;
  readOnly: boolean;
}
